export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7079.2db22d1d.jpg";